export default __webpack_public_path__ + "static/media/Screenshot_19.dd4907b6.png";